import { useCallback, useEffect, useState } from 'react';
import AuditLogsTable from '../../admin/components/access/AuditLogsTable';
import { listAuditLogs } from '../../admin/api/accessApi';

const AdminAuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState('');
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1, total: 0, limit: 20 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async (page = 1, nextSearch = '') => {
    setLoading(true);
    setError('');
    try {
      const data = await listAuditLogs({ page, limit: pagination.limit || 20, search: nextSearch });
      setLogs(data?.data || []);
      setPagination(data?.pagination || { page: 1, totalPages: 1, total: 0, limit: 20 });
    } catch (err) {
      setError(err.message || 'Unable to load audit logs.');
    } finally {
      setLoading(false);
    }
  }, [pagination.limit]);

  useEffect(() => {
    load(1, '');
  }, [load]);

  return (
    <div className="space-y-6">
      <div>
        <p className="text-xs uppercase tracking-[0.28em] text-[color:var(--admin-icon)]">Audit</p>
        <h1 className="mt-2 text-2xl font-semibold text-[color:var(--admin-heading)]">Audit Logs</h1>
        <p className="mt-2 text-sm text-[color:var(--admin-text)]">
          Search and review compact admin activity records across the platform.
        </p>
      </div>

      {error && (
        <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-600">
          {error}
        </div>
      )}

      <div className="flex flex-wrap items-center gap-3 rounded-[28px] border border-[color:var(--admin-border)] bg-white p-5 shadow-sm">
        <input
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Search action, endpoint, email, or entity"
          className="min-w-[280px] flex-1 rounded-full border border-[color:var(--admin-border)] px-4 py-3 text-sm outline-none focus:border-[var(--admin-accent)]"
        />
        <button
          type="button"
          onClick={() => load(1, search)}
          className="rounded-full bg-[var(--admin-accent)] px-5 py-3 text-xs font-semibold uppercase tracking-[0.22em] text-white"
        >
          Search
        </button>
      </div>

      <AuditLogsTable logs={logs} loading={loading} />

      <div className="flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={() => load(Math.max(1, pagination.page - 1), search)}
          disabled={pagination.page <= 1}
          className="rounded-full border border-[color:var(--admin-border)] px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-[color:var(--admin-heading)] disabled:opacity-40"
        >
          Prev
        </button>
        <p className="text-sm text-[color:var(--admin-text)]">
          Page {pagination.page} of {pagination.totalPages} ({pagination.total} total)
        </p>
        <button
          type="button"
          onClick={() => load(Math.min(pagination.totalPages, pagination.page + 1), search)}
          disabled={pagination.page >= pagination.totalPages}
          className="rounded-full border border-[color:var(--admin-border)] px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-[color:var(--admin-heading)] disabled:opacity-40"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AdminAuditLogs;
